import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticationComponent } from './authentication/authentication.component';
import { MicrosoftLegacyComponent } from './authentication/microsoft-legacy/microsoft-legacy.component';
import { ErrorComponent } from './error/error.component';
import { AuthGuardService } from './services/auth-guard.service';
import { HelpComponent } from './tabs/help/help.component';
import { InsightsComponent } from './tabs/insights/insights.component';
import { ScheduleComponent } from './tabs/schedule/schedule.component';
import { ShareComponent } from './tabs/share/share.component';
import { TabsComponent } from './tabs/tabs.component';

const routes: Routes = [
    {
        path: '',
        component: TabsComponent,
        canActivate: [AuthGuardService],
        canActivateChild: [AuthGuardService],
        children: [
            // { path: 'insights', component: InsightsComponent },
            { path: 'share', component: ShareComponent },
            { path: 'schedule', component: ScheduleComponent },
            { path: 'help', component: HelpComponent }
        ]
    },
    {
        path: 'auth',
        component: AuthenticationComponent
    },
    {
        path: 'authLegacy',
        component: MicrosoftLegacyComponent
    },
    {
        path: 'error',
        component: ErrorComponent
    }
];
@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            onSameUrlNavigation: 'reload',
            useHash: true
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}
